import { EncryptStorage } from "storage-encryption";

interface IStorage {
  encrypt(key: string, value: any): void;
  decrypt(key: string): any;
  remove(key: string): void;
}

export enum AppKey {
  USER = "USER",
  HasActiveUser = "HasActiveUser",
  SELECTEDFISCALYEAR = "SELECTEDFISCALYEAR",
  SELECTEDJOURNAL = "SELECTEDJOURNAL",
  SELECTEDJOURNALTOREVERSE = "SELECTEDJOURNALTOREVERSE",
  SELECTEDRECURRINGJOURNAL = "SELECTEDRECURRINGJOURNAL",
  SAMPLE = "SAMPLE",
  VIEWALL_STATE_DATA = "VIEWALL_STATE_DATA",
  SELECTED_MODULE_MENU = "SELECTED_MODULE_MENU",
  SELECTED_NUMBERSEQUNCE = "SELECTED_NUMBERSEQUNCE",
  SELECTEDOPERATIONACCOUNT = "SELECTEDOPERATIONACCOUNT",
  SELECTEDTRIALBALANCEACCOUNT = "SELECTEDTRIALBALANCEACCOUNT",
  TRIALBALANCEDATA = "TRIALBALANCEDATA",
  SELECTEDCONTRACT = "SELECTEDCONTRACT",
  PAGETYPE = "PAGETYPE",
  COMPANY = "COMPANY",
  LOGINMAIL = "LOGINMAIL",
  OTP = "OTP",
  SELECTEDASSET = "SELECTEDASSET",
  SELECTEDINSURANCESCHEDULE = "SELECTEDINSURANCESCHEDULE",
  SELECTEDMAINTENANCESCHEDULE = "SELECTEDMAINTENANCESCHEDULE",
  SELECTEDDISPOSALSCHEDULE = "SELECTEDDISPOSALSCHEDULE",
  SELECTEDDEPRECIATIONSCHEDULE = "SELECTEDDEPRECIATIONSCHEDULE",
  SELECTEDREVALUATIONSCHEDULE = "SELECTEDREVALUATIONSCHEDULE",
  SELECTEDASSETSTOCKLIST = "SELECTEDASSETSTOCKLIST",
  SELECTEDSPLITTINGSCHEDULE = "SELECTEDSPLITTINGSCHEDULE",
  JOURNALLISTSTATE = "JOURNALLISTSTATE",
  SELECTEDPAYROLL = "SELECTEDPAYROLL",
  SELECTEDSUBSCRIPTION = "SELECTEDSUBSCRIPTION",
  SELECTEDTENANTREQUEST = "SELECTEDTENANTREQUEST",
  SELECTEDLICENSES = "SELECTEDLICENSES",
}

export default class Store {
  private readonly storage: IStorage;
  private SECRET_KEY = "</intruder005";
  public constructor(
    getStorage = (): IStorage =>
      new EncryptStorage(this.SECRET_KEY, "sessionStorage")
  ) {
    this.storage = getStorage();
  }

  public get(key: string): any | null {
    const data = this.storage.decrypt(key);
    return data;
  }

  public set(key: string, value: any): void {
    this.storage.encrypt(key, value);
  }

  public clearItem(key: string): void {
    this.storage.remove(key);
  }
  public clearAll(except: string[] = []): void {
    Object.keys(AppKey).forEach(k => {
      if (except.length > 0 && !except.find(f => f == k)) {
        this.clearItem(k);
      }

    });
  }

  public clearItems(keys: string[]): void {
    keys.forEach((key) => this.clearItem(key));
  }
}
